export class W3FooterNavigation {
  mobileAccordionButtons: NodeListOf<Element> | null;

  constructor() {
    this.mobileAccordionButtons = document.querySelectorAll(
      "#footer .footer-accordion__button",
    );
    this.registerEventHandlers();
    this.openCurrentAccordion();
  }

  /**
   * registerEventHandlers - Register event handlers for the navigation component
   * @returns {void}
   */
  private registerEventHandlers(): void {
    if (!this.mobileAccordionButtons) return;
    this.mobileAccordionButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        const currentButton = event.target as HTMLElement;
        const isActive = currentButton.classList.contains("active");

        this.closeAllAccordions();

        if (!isActive) {
          currentButton.classList.add("active");

          const panel = currentButton.nextElementSibling;
          if (panel) {
            panel.classList.add("active");
          }
        }
      });
    });
  }

  /**
   * closeAllAccordions - Close all accordion panels by removing the active class
   * @returns {void}
   */
  private closeAllAccordions(): void {
    this.mobileAccordionButtons?.forEach((button) => {
      button.classList.remove("active");
      const panel = button.nextElementSibling;
      if (panel && panel.classList.contains("active")) {
        panel.classList.remove("active");
      }
    });
  }

  /**
   * openCurrentAccordion - Open the accordion panel for the current page
   * @returns {void}
   */
  private openCurrentAccordion(): void {
    const currentPageItem = document.querySelector(
      "#footer .footer-accordion__content .current_page_item",
    );

    if (currentPageItem) {
      const accordionButton = currentPageItem?.closest(
        ".footer-accordion__content",
      ).previousElementSibling;
      if (
        accordionButton &&
        accordionButton.classList.contains("footer-accordion__button")
      ) {
        accordionButton.classList.add("active");
        currentPageItem?.closest(".sub-menu").classList.add("active");
      }
    } else {
      this.openFirstAccordion();
    }
  }

  /**
   * openFirstAccordion - Open the first accordion panel
   */
  private openFirstAccordion(): void {
    const firstAccordionButton = document.querySelector(
      ".footer-accordion__button",
    );
    const firstSubMenu = document.querySelector(".footer-accordion__content");
    if (firstAccordionButton && firstSubMenu) {
      firstAccordionButton.classList.add("active");
      firstSubMenu.classList.add("active");
    }
  }
}
